import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AddIcon from "@mui/icons-material/Add";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FolderIcon from "@mui/icons-material/Folder";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import SyncIcon from "@mui/icons-material/Sync";
import { TreeItem, TreeView } from "@mui/lab";
import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    FormControlLabel,
    Grid,
    IconButton,
    Paper,
    Switch,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";
import DefaultApiService from "../../../../../infrastructure/api/default";
import useCheckPermission from "../../../../common/hooks/useCheckPermission";
import useGetPageInfo from "../../../../common/hooks/useGetPageInfo";
import DeleteConfirm from "../../../../components/shared/Dialog/DeleteConfirm";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import EnhancedTable from "../../../../components/shared/table";

const getTreeItemsFromData = (treeItems, parentId, level) => {
  return treeItems.map((treeItemData) => {
    let children;
    let list = treeItemData.child;

    if (list && list.length > 0) {
      children = getTreeItemsFromData(
        list,
        `${parentId}-${treeItemData.id}`,
        level + 1
      );
    }

    return (
      <TreeItem
        key={`${parentId}-${treeItemData.id}`}
        nodeId={`${parentId}-${treeItemData.id}`}
        label={
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {treeItemData.level > 2 ||
            (treeItemData.level === 2 && treeItemData.controller) ? (
              <InsertDriveFileIcon />
            ) : level ? (
              // <MenuOpenIcon />
              <FolderIcon />
            ) : (
              <AccountTreeIcon />
            )}
            &nbsp;
            {treeItemData.title}
          </Box>
        }
        children={children}
      />
    );
  });
};

const onGetChildIds = (node, prev) => {
  let list = node.child;

  if (list?.length > 0) {
    let ids = [];
    for (let i = 0; i < list.length; i++) {
      const item = list[i];
      ids = [
        ...ids,
        `${prev}-${node.id}`,
        //...onGetChildIds(item, `${prev}-${node.id}`),
      ];
    }
    return ids;
  } else {
    return [];
  }
};

const onFindNodeId = (list, ids) => {
  const currentId = ids[0];
  const otherIds = ids.slice(1);
  if (list.length > 0) {
    const item = list.find((x) => x.id == currentId);
    if (item) {
      if (otherIds.length > 0) {
        let children = item.child;
        return [item, ...onFindNodeId(children, otherIds)];
      } else {
        return [item];
      }
    }
  }

  return null;
};

const headCells = [
  {
    id: "updateOn",
    label: "تاریخ بروزرسانی",
    type: "date",
  },
  {
    id: "title",
    label: "عنوان",
  },
  {
    id: "level",
    // disablePadding: false,
    label: "سطح",
  },
  {
    id: "controller",
    label: "کنترلر",
  },
  // {
  //   id: "userKind",
  //   disablePadding: false,
  //   label: "نوع مخاطب",
  // },
  {
    id: "priority",
    label: "اولویت",
  },
  // {
  //   id: "isActive",
  //   type: "boolean",
  //   disablePadding: false,
  //   label: "وضعیت",
  // },
  {
    id: "price",
    label: "قیمت",
    type: "number",
  },
  {
    id: "userDescription",
    label: "توضیحات کاربر",
  },
];

const ModuleListPage = () => {
  const contentTreeList = useLoaderData("root");
  const pageInfo = useGetPageInfo();

  let navigate = useNavigate();
  const [deleteConfirm, setDeleteConfirm] = useState({
    open: false,
    data: {},
    cascadeDelete: false,
  });

  const [content, setContent] = useState(contentTreeList[0].child);
  const [expanded, setExpanded] = useState(["node-1"]);
  const [selected, setSelected] = useState(["node-1"]);

  useEffect(() => {
    if (contentTreeList) {
      setContent(contentTreeList[0].child);
      setExpanded(["node-1"]);
      setSelected(["node-1"]);
    }
  }, [contentTreeList]);

  const onFetchData = () => {
    setExpanded([]);
    setSelected([]);
    navigate();
    setContent([]);
  };

  const onEditClicked = (row) => {
    navigate(`/MNG/Menu/ModuleList/${row.id}?treeId=${row.treeId || "root"}`);
  };

  const onChildClicked = (row) => {
    // setTreeId(row.id); // Step 2: Set the treeId when a row is clicked
    // setParentIds((prevParentIds) => [...prevParentIds, row.id]);
    // navigate(`/JP/Management/Content/${row.id}`, { state: { parentIds } });
  };

  const onDeleteClicked = (row) => {
    setDeleteConfirm((old) => ({ ...old, open: true, data: row }));
  };

  const confirmedDelete = () => {
    return DefaultApiService.deleteOneApi("/MNG/Menu/ModuleList", {
      id: deleteConfirm.data.id,
      cascadeDelete: deleteConfirm.cascadeDelete,
    });
  };

  const onNodeSelect = (e, nodeId) => {
    const ids = nodeId.split("-");
    const nodes = onFindNodeId(contentTreeList, ids.slice(1));
    // debugger;
    if (nodes?.length) {
      const node = nodes[nodes.length - 1];

      if (!(node.level > 2 || (node.level === 2 && node.controller))) {
        setSelected([nodeId]);

        setContent(node.child);
      }
    } else {
      setContent([]);
    }
  };

  const onNodeFocus = (e, nodeId) => {
    const ids = nodeId.split("-");

    let finalList = [];
    if (expanded.find((x) => x === nodeId)) {
      finalList = expanded.filter((node) => node !== nodeId);
    } else {
      if (ids.length === 2) {
        const node = contentTreeList.find((x) => x.id == ids[1]);
        const childIds = onGetChildIds(node, ids[0]);
        finalList = [...childIds];
      } else finalList = [...expanded, nodeId];
    }

    setExpanded(finalList);
  };

  const onCreate = () => {
    let treeId = "root",
      projectId = "Module";

    if (selected.length > 0) {
      const ids = selected[0].split("-");
      if (ids.length > 2) {
        treeId = ids[ids.length - 1];
      }

      const nodes = onFindNodeId(contentTreeList, ids.slice(1));

      if (nodes?.length) {
        // const node = nodes[nodes.length - 1];
        const parent = nodes[0];
        projectId = parent.id;
      }
    }

    navigate(
      `/MNG/Menu/ModuleList/create?treeId=${
        treeId !== "0" ? treeId : "root"
      }&projectId=${projectId}`
    );
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />

        <DeleteConfirm
          message={`برای حذف "${deleteConfirm.data.title}" اطمینان دارید؟`}
          open={deleteConfirm.open}
          onClose={(loadAgain) => {
            setDeleteConfirm({
              open: false,
              data: {},
              cascadeDelete: false,
            });
            if (loadAgain) {
              navigate();
            }
          }}
          onSubmit={confirmedDelete}
        >
          <FormControlLabel
            name="cascadeDelete"
            checked={deleteConfirm.cascadeDelete}
            onChange={(event) => {
              setDeleteConfirm((old) => ({
                ...old,
                cascadeDelete: event.target.checked,
              }));
            }}
            control={<Switch color="danger" />}
            label="حذف از تمامی جاهایی که استفاده شده است"
          />
        </DeleteConfirm>
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={pageInfo.title}
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                {useCheckPermission("create") && (
                  <Button
                    onClick={onCreate}
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                  >
                    ایجاد
                  </Button>
                )}

                <Divider
                  orientation="vertical"
                  variant="middle"
                  flexItem
                  sx={{ mx: 1 }}
                />

                <IconButton
                  variant="text"
                  color="primary"
                  onClick={onFetchData}
                >
                  <SyncIcon />
                </IconButton>
              </Box>
            }
          />

          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12} md={3}>
                <Paper
                  elevation={3}
                  sx={{
                    p: 2,
                    height: "70vh",
                    overflow: "auto",
                    boxShadow: "0px 12px 21px 2px rgba(218, 230, 249, 0.4)",
                  }}
                >
                  <TreeView
                    defaultCollapseIcon={<ExpandMoreIcon />}
                    defaultExpandIcon={<ChevronLeftIcon />}
                    selected={selected}
                    onNodeSelect={onNodeSelect}
                    expanded={expanded}
                    onNodeFocus={onNodeFocus}
                    className="tree-view-container"
                  >
                    {getTreeItemsFromData(contentTreeList, "node", 0)}
                  </TreeView>
                </Paper>
              </Grid>

              <Grid item xs={12} md={9}>
                <EnhancedTable
                  rowKey={"id"}
                  rows={content}
                  headCells={headCells}
                  pageSize={100}
                  actions={[
                    // {
                    //   icon: useCheckPermission("edit") ? (
                    //     <AccountTree sx={{ width: "1rem", height: "1rem" }} />
                    //   ) : null,
                    //   onClick: onChildClicked,
                    //   color: "primary",
                    // },
                    {
                      icon: useCheckPermission("edit") ? (
                        <EditIcon sx={{ width: "1rem", height: "1rem" }} />
                      ) : null,
                      onClick: onEditClicked,
                      color: "primary",
                    },
                    {
                      icon: useCheckPermission("delete") ? (
                        <DeleteIcon sx={{ width: "1rem", height: "1rem" }} />
                      ) : null,
                      onClick: onDeleteClicked,
                      color: "secondary",
                    },
                  ]}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ModuleListPage;
